Object.superGet = (superPrototype, name, instance) => {
	do {
		const descriptor = Object.getOwnPropertyDescriptor(superPrototype, name)
		if (descriptor) {
			return descriptor.get ? descriptor.get.call(instance) : descriptor.value
		}
	} while ((superPrototype = Object.getPrototypeOf(superPrototype)))
}

Object.superSet = (superPrototype, name, instance, value) => {
	do {
		const descriptor = Object.getOwnPropertyDescriptor(superPrototype, name)
		if (descriptor) {
			return descriptor.set && descriptor.set.call(instance, value)
		}
	} while ((superPrototype = Object.getPrototypeOf(superPrototype)))
	Object.defineProperty(instance, name, {
		value,
		configurable: true,
		enumerable: true,
		writable: true,
	})
}
